import setCriticalError from './set-critical-error';
import setNetworkStatus from './set-network-status';

export default {
  setCriticalError,
  setNetworkStatus,
};
